
export default function (Component) {
  Component.options.__source = "src/layout/no-header/components/tabs/index.vue"
}
